// MUI-free copy of Ui-components/MobileProcess.
import React, {memo} from 'react';
import parse from 'html-react-parser';
import styles from './MobileProcess.module.scss';

export interface MobileProcessItem {
    heading?: string;
    description?: string;
}

interface MobileProcessProps {
    mobileProcess?: MobileProcessItem[];
}

// Literal lookup (PurgeCSS only keeps class names written out in full). Steps past the sixth get no
// colour, as the original's PROCESS_COIN_COLORS[index] did.
const COIN_COLOR_CLASSES = [styles.coin1, styles.coin2, styles.coin3, styles.coin4, styles.coin5, styles.coin6] as const;

const MobileProcess = ({mobileProcess}: MobileProcessProps) => (
    <div>
        {mobileProcess?.map((item, index) => (
            <div key={index + 1} className={styles.step}>
                <div className={styles.headerWrapper}>
                    <div className={[styles.coin, COIN_COLOR_CLASSES[index]].filter(Boolean).join(' ')}>{index + 1}</div>

                    <p className={styles.heading}>{item.heading ? parse(item.heading) : ''}</p>
                </div>
                <div>
                    <p className={`ai-agent-done-subheading ${styles.subheading}`}>{item.description ? parse(item.description) : ''}</p>
                </div>
            </div>
        ))}
    </div>
);

export default memo(MobileProcess);
